import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BillTypes } from '../models';

const initialState = {
  billDetail: {},
  activeScreen: '',
};

const billSlice = createSlice({
  name: 'billSlice',
  initialState,
  reducers: {
    setBillDetail(state, action: PayloadAction<any>) {
      state.billDetail = action.payload;
      if (action?.payload?.id) {
        localStorage.setItem('bill_id', action?.payload?.id);
      }
    },
    setActiveScreen(state, action: PayloadAction<string>) {
      state.activeScreen = action.payload;
    },
  },
});

// Actions
export const { setBillDetail, setActiveScreen } = billSlice.actions;

// Reducer
const billReducer = billSlice.reducer;
export default billReducer;
